import { Content } from '../../types';

export const huaHinAttractionsContent: Content = {
  title: 'אטרקציות טבע ונופש בסביבת הואה הין - חווייה תאילנדית של ממש',
  imageUrl:
    '/images/thailand/hua-hin-attractions/hua-hin-attractions-wide.jpeg',
  introduction:
    'הואה הין Hua Hin, עיירת נופש ידועה לחוף מפרץ תאילנד, הפכה עם השנים לאחד היעדים האהובים בתאילנד - הן על המקומיים והן על התיירים הזרים. מיקומה האסטרטגי, כשעתיים וחצי נסיעה דרומית מערבית לבנגקוק, מגוון עצום של אתרי טבע, תרבות ופנאי - הופכים אותה לבסיס מצויין לטיולים יומיים ולשימושכם ולהנאתכם, מצורפת רשימת האטרקציות והאתרים שאסור לפספס באזור:',
  sections: [
    {
      title: 'אתרי טבע',
      type: 'sub-headers',
      description:
        'האזור סביב הואה הין מתברך בטבע ייחודי ומגוון, המשלב שמורות טבע, מפלים ונופים מרהיבים. אלו מהווים חלק בלתי נפרד מחוויית הביקור באזור ומספקים מפלט מושלם משאון העיר.',
      content: [
        {
          subtitle: 'שמורת הטבע Kaeng Krachan ומפלי Pala-U',
          text: "מפלי Pala U נחשבים לאחת מגולות הכותרת של שמורת הטבע קאנג קראצ'אן (Kaeng Krachan) - השמורה הגדולה בתאילנד המשתרעת על פני כ-3,000 קמ\"ר, בין הואה הין לגבול עם מיאנמר. השמורה עשירה ביערות גשם טרופיים, מיני בעלי חיים נדירים, פרפרים נדירים, סחלבים מדהימים ועוד.<br /><br />המסלול לאורך מפלי השמורה, כולל כ - 15 שלבים בדרגות קושי שונות. במקטעים שונים אף יידרש טיפוס קל בסיוע חבלים, אך אין צורך להתאים את הביקור לרמת כשירות מיוחדת. מומלץ לעצור במפל הרביעי שבו בריכה טבעית לשחייה - חוויה קרירה בלב הג'ונגל. הדרך למפלים אורכת כשעה וחצי מהואה הין, עיקרה בדרכים כפריות יפהפיות.",
        },
        {
          subtitle: 'שמורת הטבע Sam Roi Yot ומערת Phraya Nakhon',
          text: 'המקום הזה ייחרט בזיכרונכם - מערה מרהיבה ולדעת רבים - המערה היפה בתאילנד, בלב שמורת הטבע Sam Roi Yot - שפירוש שמה בתאילנדית הוא "שלוש מאות הפסגות". המערה בנויה למעשה משתי מערות, הגדולה - Phraya Nakhon והקטנה - Sai כשבמרכז האולם המרכזי מצוי פביליון מלכותי קטן, אשר הוקם לרגל הנצחת ביקורו של המלך ראמה החמישי במקום, בשנת 1896.<br /><br />קרני שמש החודרות דרך הפתח שבתקרת המערה, יוצרות אפקט מואר ומרהיב, מה שמעניק למקום אווירה מיסטית. ניתן להגיע ברגל (מסלול של כ-2 ק"מ) או בשילוב שייט בסירת לונג-טייל אל כפר הדייגים הציורי Ban Pu. הנסיעה לשמורה אורכת כ-45 דקות בלבד מהואה הין.',
        },
      ],
    },
    {
      title: 'אתרי דת ותרבות',
      type: 'sub-headers',
      description:
        'מקדשים ואתרי תרבות מהווים חלק חשוב מהמורשת התאילנדית ומאפשרים הצצה ייחודית לתרבות ולמסורת המקומית.',
      content: [
        {
          subtitle: 'מקדש Huay Mongkol',
          text: 'אתר בודהיסטי מרשים ובו פסל הברונזה הגדול בעולם של הנזיר Luang Phor Thuad - קדוש בודהיסטי ידוע בדרום תאילנד, אשר מיוחסים לו ניסים והגנות מרוע. המקדש, הבנוי בלב אזור כפרי פסטורלי (כ-15 ק"מ מהואה הין), משלב אלמנטים של פארק, אגם קטן ופסלים נוספים. מומלץ לבקר בסופי שבוע כדי לחוות את ההווי המקומי ואת האמונה החיה של המבקרים הרבים.',
        },
        {
          subtitle: 'תחנת הרכבת המלכותית',
          text: 'מבנה היסטורי יפהפה, נחשב לאחד האייקונים של הואה הין. התחנה מהווה עדות לתקופה שבה הואה הין החלה להתפתח כיעד נופש מלכותי, והיא משמרת את האדריכלות והסגנון של התקופה המלכותית בתאילנד.',
        },
      ],
    },
    {
      title: 'Luang Phor Thuad',
      content: '',
      type: 'image',
      imageUrl:
        '/images/thailand/hua-hin-attractions/hua-hin-attractions-article-1.jpeg',
    },
    {
      title: 'שווקים ואווירה מקומית',
      type: 'sub-headers',
      description:
        'השווקים בהואה הין מציעים חוויה תרבותית עשירה, טעמים מקומיים אותנטיים וקניות מעניינות. הם מהווים חלק בלתי נפרד מהאווירה המקומית ומהחוויה התאילנדית.',
      content: [
        {
          subtitle: 'שוק הלילה המרכזי של הואה הין',
          text: 'שוק הלילה המרכזי של הואה הין, מהווה מוקד תרבותי וקולינרי תוסס. הוא משתרע לאורך רחוב Dechanuchit הסמוך לרחוב Phetchkasem ומגיע כמעט עד תחנת הרכבת המלכותית. הרחוב הופך למדרחוב בכל ערב ולצד דוכני אוכל רחוב מהטובים בתאילנד, נמכרים בו אף עבודות יד, תכשיטים, מוצרי טקסטיל, מזכרות ועוד.',
        },
        {
          subtitle: 'Cicada Market',
          text: 'שוק ייחודי המציע במה לאמנים מקומיים, הופעות חיות, דוכני בוטיק, אוכל משובח ואווירה קצת יותר אלטרנטיבית. ייחודו של השוק נעוץ בהופעות חיות, אמנים מקומיים ותחושת הקהילתיות שבו. השוק פועל בסופי שבוע ומומלץ ביותר לבקר בו.',
        },
        {
          subtitle: 'Tamarind Market',
          text: 'שוק נוסף הפועל בסופי שבוע ומציע הרבה דוכני אוכל מושקעים מסוגים שונים ומגוונים, דוכני ביגוד, אווירה צעירה ורגועה ומוזיקה חיה נהדרת.',
        },
      ],
    },
    {
      title: 'אטרקציות לכל המשפחה',
      type: 'sub-headers',
      description:
        'הואה הין מציעה מגוון אטרקציות המתאימות לכל המשפחה, המשלבות הנאה ובילוי עם חוויות ייחודיות.',
      content: [
        {
          subtitle: 'עיירת הנופש Cha-Am',
          text: "צ'ה אם Cha Am שוכנת צפונית להואה הין ומהווה יעד פופולארי לנופש בקרב מקומיים ותיירים כאחד. חוף הים הארוך שלה, בעל חול כסוף ומים רגועים, שקט ומרווח יותר מהחופים המרכזיים של הואה הין. אידיאלי למשפחות ולזוגות המחפשים חופשה שלווה.<br /><br />אחת החוויות המיוחדות בעיירה, הינה רכיבה על אופניים משפחתיים לאורך החוף - עם עצירה בבתי קפה ציוריים וצפייה בשקיעה. בנוסף, ממוקם בסמוך לעיירה מתחם Premium Outlet גדול עם חנויות ומותגים שונים, במחירים משתלמים.",
        },
        {
          subtitle: 'חוות סוסים ו/ או פילים',
          text: 'אזור הואה הין מציע מספר חוות שבהן ניתן לפגוש חיות מקרוב (יש לבדוק המלצות עדכניות על מקומות הפועלים בצורה אתית בלבד).',
        },
        {
          subtitle: 'פארק המים Vana Nava Water Jungle',
          text: 'פארק מים מודרני ומושקע, החדיש ביותר באזור, אידיאלי למשפחות עם ילדים.',
        },
        {
          subtitle: 'חוות היין Monsoon Valley',
          text: 'סיור וטעימות יין בנוף גבעות ירוקות, כ-40 דקות מהעיר.',
        },
      ],
    },
    {
      title: '',
      type: 'text',
      isBold: true,
      content:
        'בשורה התחתונה, הואה הין והסביבה מציעות שילוב נהדר, רגוע ושקט, של נופש חופי, אתרי טבע עוצרי נשימה, נופים מיוחדים, תרבויות ושווקים ססגוניים, המהווים יעד נופש מומלץ ביותר ובקרבה לבנגקוק.',
    },
  ],
};
